import { ReactNode } from "react";
import { TableColumnHeaderProps, Th } from "@chakra-ui/react";

interface TableHeaderCellProps extends TableColumnHeaderProps {
	children: ReactNode;
	isNumeric?: boolean;
	centered?: boolean;
	small?: boolean;
	onClick?: () => void;
}

const TableHeaderCell = ({
	children,
	isNumeric,
	centered,
	small,
	onClick = () => {},
	...props
}: TableHeaderCellProps) => {
	return (
		<Th
			onClick={onClick}
			isNumeric={isNumeric}
			textAlign={centered ? "center" : "left"}
			{...props}
		>
			{children}
		</Th>
	);
};

export default TableHeaderCell;
